import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { PieChartModule } from '@core/components/charts/pie/pie.module';
import { StackedChartModule } from '@core/components/charts/stacked/stacked.module';
import { DataCardModule } from '@core/components/data-card/data-card.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterModule } from 'app/main/reports/components/filter/filters.module';
import { ReportFilterState } from '../components/filter/services/report-filter-state.service';
import { DashboardEquipmentsComponent } from './dashboard-equipments.component';
import { QueryDashboardEquipmentsDataGQL } from './services/api/queries.service';

const routes: Routes = [
  {
    path: 'relatorios/equipamentos',
    component: DashboardEquipmentsComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.EQUIPMENTS' }
  }
];

@NgModule({
  declarations: [
    DashboardEquipmentsComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    DataCardModule,
    PieChartModule,
    StackedChartModule,
    FilterModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    PipesModule,
    CommonModule
  ],
  exports: [
    DashboardEquipmentsComponent
  ],
  providers: [
    ReportFilterState,
    QueryDashboardEquipmentsDataGQL,
  ]
})

export class DashboardEquipmentsModule { }
